import React from 'react';
import { getStaticFilesURL } from '@noths/polaris-client-static-files';
import type { CSSProp } from 'styled-components';

import { flag } from './Flag.styles';

export interface FlagProps {
  countryCode: string;
  countryName: string;
  styles?: CSSProp;
  width?: number;
}

export const Flag = ({ countryCode, countryName, styles, width }: FlagProps) => {
  const flagURL = getStaticFilesURL('production', `img/flags/${countryCode}.png`);

  return (
    <img
      alt={`Country: ${countryName}`}
      css={[styles, flag]}
      data-testid="flag-icon"
      src={flagURL}
      width={width ? `${width}px` : undefined}
    />
  );
};
